import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  Button,
  FormGroup,
  FormField,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardBillingDepositHistoryDetailUX = (props: any) => {
    return(
      <div
        className="ui form"
        id="CardBillingDepositHistoryUX-div-0"
        style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{ display:  "flex", justifyContent: "space-between",  padding: "10px 10px 0px 10px"  }}>
          
          <div
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            รายละเอียดการใช้เงินมัดจำ
          </div>
          <div
            style={{ fontSize: "1.2rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            
          </div>
        </div>
        <div
          style={{padding: "0px 10px 10px 10px", display: props.viewMode ? "none" : "" }}>
          
          <hr>
          </hr>
        </div>
        <div
          className="--override-disabled --grey"
          style={{ display: "flex", margin: "10px 15px", flexDirection: "column"  }}>
          
          <Form>
            <FormGroup
              id="CardBillingDepositHistoryDetailUX-FormGroup-304">
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-306"
                style={{ marginRight: "20px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-320">
                  รหัสเอกสารเงินมัดจำ
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-307"
                style={{ marginRight: "20px" }}
                width={3}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-319">
                  เลขที่ใบเสร็จที่รับชำระด้วยเงินมัดจำ
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-308"
                style={{ marginRight: "20px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-318">
                  วัน - เวลาที่รับชำระ
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-309"
                style={{ marginRight: "20px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-317">
                  ยอดเงินที่ตัดใช้
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-310"
                style={{ marginRight: "20px" }}
                width={3}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-316">
                  เจ้าหน้าที่ผู้รับชำระ
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBillingDepositHistoryDetailUX-FormGroup-305">
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-311"
                style={{ marginRight: "20px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-325">
                  {}
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-330"
                    size="mini"
                    value={props.selectDepositHistory?.deposit_code}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-312"
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-324">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-329"
                    size="mini"
                    value={props.selectDepositHistory?.payment_receipt_no}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardBillingDepositHistoryDetailUX-FormField-331"
                style={{ marginRight: "20px" }}
                width={1}>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-313"
                style={{ marginRight: "20px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-323">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-328"
                    size="mini"
                    value={props.selectDepositHistory?.payment_datetime}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-314"
                style={{ marginRight: "20px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-322">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-327"
                    size="mini"
                    value={`${props.selectDepositHistory?.value || 0} บาท`}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-315"
                style={{ marginRight: "20px" }}
                width={3}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-321">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-326"
                    size="mini"
                    value={props.selectDepositHistory?.payment_cashier}>
                  </Input>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          style={{ margin: "20px 10px 10px 10px" }}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.receiptMode}
            headers="รหัสหมวด,ชื่อหมวดค่ารักษาพยาบาล,ราคา,ส่งเบิก,absorb,เบิกเอง,เบิกไม่ได้,ส่วนลด,ผู้ป่วยชำระ"
            id="CardBillingDepositHistoryDetailUX-Table-212"
            keys="bill_mode__code, bill_mode__name, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum"
            minRows="10"
            showPagination={false}
            style={{ height: "50vh", ...(props.type === "item" && { display: "none" }) }}>
          </Table>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.receiptItem}
            headers="รหัสหมวด,รหัสค่ารักษา,ชื่อรายการค่ารักษาพยาบาล,วันที่และเวลาค่าใช้จ่าย,จำนวน,ราคาต่อหน่วย,ราคา,ส่งเบิก,absorb,เบิกเอง,เบิกไม่ได้,ส่วนลด,ผู้ป่วยชำระ,ส่วนลดสิทธิ,รหัสส่วนลด"
            id="CardBillingDepositHistoryDetailUX-Table-213"
            keys="mode_code, code, product, edited, quantity, unitprice, price, send_claim, absorb, claimable, non_claimable, discount, payable, drg_discount_amount, discount_code"
            minRows="10"
            showPagination={false}
            style={{ height: "50vh", ...(props.type === "mode" && { display: "none" }) }}
            widths="100,100,140">
          </Table>
        </div>
        <div
          id="CardBillingDepositHistoryDetailUX-div-214"
          style={{ display: "flex", margin: "10px 15px"  }}>
          
          <div
            id="CardBillingDepositHistoryDetailUX-div-217">
            
            <Button
              className={props.type === "mode" ? "active" : ""}
              color="teal"
              id="CardBillingDepositHistoryDetailUX-Button-218"
              name="mode"
              onClick={props.onChangeType}
              size="mini">
              รายหมวดค่ารักษา
            </Button>
            <Button
              className={props.type === "item" ? "active" : ""}
              color="teal"
              id="CardBillingDepositHistoryDetailUX-Button-219"
              name="item"
              onClick={props.onChangeType}
              size="mini">
              รายการค่ารักษา
            </Button>
          </div>
        </div>
        <div
          className="--override-disabled --grey"
          id="CardBillingDepositHistoryDetailUX-div-215"
          style={{ display: "flex", margin: "10px 15px", flexDirection: "column"  }}>
          
          <Form
            id="CardBillingDepositHistoryDetailUX-Form-220">
            <FormGroup
              id="CardBillingDepositHistoryDetailUX-FormGroup-262">
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-264"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-287">
                  {props.languageUX === "en" ? "Total price" : "ราคารวม"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-265"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-286">
                  {props.languageUX === "en" ? "Send for disbursement" : "ส่งเบิก"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-266"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-285">
                  {props.languageUX === "en" ? "Absorb" : "ดูดซับ"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-267"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-284">
                  {props.languageUX === "en" ? "Withdraw it yourself" : "เบิกเอง"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-268"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-283">
                  {props.languageUX === "en" ? "Unable to withdraw" : "เบิกไม่ได้"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-269"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-282">
                  {props.languageUX === "en" ? "Discount" : "ส่วนลด"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-270"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-281">
                  {props.languageUX === "en" ? "Patient payment" : "ผู้ป่วยชำระ"}
                </label>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-271"
                style={{ marginRight: "10px" }}
                width={2}>
                <label
                  id="CardBillingDepositHistoryDetailUX-label-280">
                  ส่วนลดสิทธิ
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardBillingDepositHistoryDetailUX-FormGroup-263">
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-272"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-295">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-296"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.price}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-273"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-294">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-297"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.send_claim}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-274"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-293">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-298"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.absorb}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-275"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-292">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-299"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.claimable}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-276"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-291">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-300"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.non_claimable}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-277"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-290">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-301"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.discount}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-278"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-289">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-302"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.payable}>
                  </Input>
                </div>
              </FormField>
              <FormField
                className="noPadding --hard"
                id="CardBillingDepositHistoryDetailUX-FormField-279"
                style={{ marginRight: "10px" }}
                width={2}>
                <div
                  id="CardBillingDepositHistoryDetailUX-div-288">
                  
                  <Input
                    disabled={true}
                    id="CardBillingDepositHistoryDetailUX-Input-303"
                    size="mini"
                    value={props.selectDepositHistory?.sumPrice?.drg_discount_amount}>
                  </Input>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingDepositHistoryDetailUX-div-216"
          style={{ display: "flex", margin: "10px 15px 20px", justifyContent:"flex-end"  }}>
          
          <div
            id="CardBillingDepositHistoryDetailUX-div-260">
            
            <Button
              id="CardBillingDepositHistoryDetailUX-Button-261"
              onClick={props.onCloseDetail}
              size="mini">
              ปิดหน้าต่าง
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardBillingDepositHistoryDetailUX

export const screenPropsDefault = {"by":"order","title":"MEDICAL FEE","titleDescription":"ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"}

/* Date Time : Thu Sep 04 2025 14:46:07 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display:  \"flex\", justifyContent: \"space-between\",  padding: \"10px 10px 0px 10px\"  }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 10px 10px\", display: props.viewMode ? \"none\" : \"\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการใช้เงินมัดจำ"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "hr",
      "parent": 131,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 134,
      "void": true
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 15px\", flexDirection: \"column\"  }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"20px 10px 10px 10px\" }"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Form",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 212,
      "name": "Table",
      "parent": 136,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.receiptMode"
        },
        "headers": {
          "type": "value",
          "value": "รหัสหมวด,ชื่อหมวดค่ารักษาพยาบาล,ราคา,ส่งเบิก,absorb,เบิกเอง,เบิกไม่ได้,ส่วนลด,ผู้ป่วยชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Table-212"
        },
        "keys": {
          "type": "value",
          "value": "bill_mode__code, bill_mode__name, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPageSizeOptions": {
          "type": "code",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\", ...(props.type === \"item\" && { display: \"none\" }) }"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 213,
      "name": "Table",
      "parent": 136,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.receiptItem"
        },
        "headers": {
          "type": "value",
          "value": "รหัสหมวด,รหัสค่ารักษา,ชื่อรายการค่ารักษาพยาบาล,วันที่และเวลาค่าใช้จ่าย,จำนวน,ราคาต่อหน่วย,ราคา,ส่งเบิก,absorb,เบิกเอง,เบิกไม่ได้,ส่วนลด,ผู้ป่วยชำระ,ส่วนลดสิทธิ,รหัสส่วนลด"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Table-213"
        },
        "keys": {
          "type": "value",
          "value": "mode_code, code, product, edited, quantity, unitprice, price, send_claim, absorb, claimable, non_claimable, discount, payable, drg_discount_amount, discount_code"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\", ...(props.type === \"mode\" && { display: \"none\" }) }"
        },
        "widths": {
          "type": "value",
          "value": "100,100,140"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-214"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 15px\"  }"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-215"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 15px\", flexDirection: \"column\"  }"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 216,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-216"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 15px 20px\", justifyContent:\"flex-end\"  }"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "div",
      "parent": 214,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-217"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "Button",
      "parent": 217,
      "props": {
        "children": {
          "type": "value",
          "value": "รายหมวดค่ารักษา"
        },
        "className": {
          "type": "code",
          "value": "props.type === \"mode\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Button-218"
        },
        "name": {
          "type": "value",
          "value": "mode"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeType"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "Button",
      "parent": 217,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการค่ารักษา"
        },
        "className": {
          "type": "code",
          "value": "props.type === \"item\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Button-219"
        },
        "name": {
          "type": "value",
          "value": "item"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeType"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 220,
      "name": "Form",
      "parent": 215,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Form-220"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 216,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-260"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 261,
      "name": "Button",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": "ปิดหน้าต่าง"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Button-261"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseDetail"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 262,
      "name": "FormGroup",
      "parent": 220,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormGroup-262"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 263,
      "name": "FormGroup",
      "parent": 220,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormGroup-263"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-264"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 265,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-265"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-266"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 267,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-267"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 268,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-268"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 269,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-269"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 270,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-270"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 271,
      "name": "FormField",
      "parent": 262,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-271"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 272,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-272"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 273,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-273"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 274,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-274"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 275,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-275"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 276,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-276"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 277,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-277"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 278,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-278"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "FormField",
      "parent": 263,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-279"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 280,
      "name": "label",
      "parent": 271,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลดสิทธิ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-280"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "label",
      "parent": 270,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient payment"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-281"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "label",
      "parent": 269,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "Discount"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-282"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": null,
      "id": 283,
      "name": "label",
      "parent": 268,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Unable to withdraw"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-283"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": null,
      "id": 284,
      "name": "label",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง",
          "valueEN": "Withdraw it yourself"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-284"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": null,
      "id": 285,
      "name": "label",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": "ดูดซับ",
          "valueEN": "Absorb"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-285"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "label",
      "parent": 265,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Send for disbursement"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-286"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 287,
      "name": "label",
      "parent": 264,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-287"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 279,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-288"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "div",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-289"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-290"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": null,
      "id": 291,
      "name": "div",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-291"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": null,
      "id": 292,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-292"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 293,
      "name": "div",
      "parent": 274,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-293"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": null,
      "id": 294,
      "name": "div",
      "parent": 273,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-294"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 295,
      "name": "div",
      "parent": 272,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-295"
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 296,
      "name": "Input",
      "parent": 295,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-296"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.price"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 297,
      "name": "Input",
      "parent": 294,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-297"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.send_claim"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 298,
      "name": "Input",
      "parent": 293,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-298"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.absorb"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 299,
      "name": "Input",
      "parent": 292,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-299"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.claimable"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 300,
      "name": "Input",
      "parent": 291,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-300"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.non_claimable"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 301,
      "name": "Input",
      "parent": 290,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-301"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.discount"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 302,
      "name": "Input",
      "parent": 289,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-302"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.payable"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 303,
      "name": "Input",
      "parent": 288,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-303"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.sumPrice?.drg_discount_amount"
        }
      },
      "seq": 303,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 304,
      "name": "FormGroup",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormGroup-304"
        }
      },
      "seq": 304,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 305,
      "name": "FormGroup",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormGroup-305"
        }
      },
      "seq": 305,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 306,
      "name": "FormField",
      "parent": 304,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-306"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 307,
      "name": "FormField",
      "parent": 304,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-307"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 308,
      "name": "FormField",
      "parent": 304,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-308"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 308,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 309,
      "name": "FormField",
      "parent": 304,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-309"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 310,
      "name": "FormField",
      "parent": 304,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-310"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 311,
      "name": "FormField",
      "parent": 305,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-311"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 312,
      "name": "FormField",
      "parent": 305,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-312"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 313,
      "name": "FormField",
      "parent": 305,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-313"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 314,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 314,
      "name": "FormField",
      "parent": 305,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-314"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 315,
      "name": "FormField",
      "parent": 305,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-315"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 331,
      "void": false
    },
    {
      "from": null,
      "id": 316,
      "name": "label",
      "parent": 310,
      "props": {
        "children": {
          "type": "value",
          "value": "เจ้าหน้าที่ผู้รับชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-316"
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": null,
      "id": 317,
      "name": "label",
      "parent": 309,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดเงินที่ตัดใช้"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-317"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": null,
      "id": 318,
      "name": "label",
      "parent": 308,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน - เวลาที่รับชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-318"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": null,
      "id": 319,
      "name": "label",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จที่รับชำระด้วยเงินมัดจำ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-319"
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": null,
      "id": 320,
      "name": "label",
      "parent": 306,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสเอกสารเงินมัดจำ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-label-320"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": null,
      "id": 321,
      "name": "div",
      "parent": 315,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-321"
        }
      },
      "seq": 321,
      "void": false
    },
    {
      "from": null,
      "id": 322,
      "name": "div",
      "parent": 314,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-322"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": null,
      "id": 323,
      "name": "div",
      "parent": 313,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-323"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": null,
      "id": 324,
      "name": "div",
      "parent": 312,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-324"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": null,
      "id": 325,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-div-325"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 326,
      "name": "Input",
      "parent": 321,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-326"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.payment_cashier"
        }
      },
      "seq": 326,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 327,
      "name": "Input",
      "parent": 322,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-327"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "`${props.selectDepositHistory?.value || 0} บาท`"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 328,
      "name": "Input",
      "parent": 323,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-328"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.payment_datetime"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 329,
      "name": "Input",
      "parent": 324,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-329"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.payment_receipt_no"
        }
      },
      "seq": 329,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 330,
      "name": "Input",
      "parent": 325,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-Input-330"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.selectDepositHistory?.deposit_code"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 331,
      "name": "FormField",
      "parent": 305,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDepositHistoryDetailUX-FormField-331"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 313,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingDepositHistoryDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "by": "order",
    "title": "MEDICAL FEE",
    "titleDescription": "ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"
  },
  "width": 80
}

*********************************************************************************** */
